import { Component, OnInit } from '@angular/core';
import { MatDialog, MatSelectChange } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { AppState } from '../../../models/appState';
import { CompanyRef, Parameter } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { UiService } from '../../../services/ui.service';
import { take } from 'rxjs/operators';
import { DataSourceService } from '../../../services/data-source.service';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';

@Component({
  selector: 'app-pending-list-parameters',
  templateUrl: './pending-list-parameters.component.html',
  styleUrls: ['./pending-list-parameters.component.scss']
})
export class PendingListParametersComponent implements OnInit {
  contentLocation: AppState = new AppState();
  parameterSubscription: Subscription;

  savingParameters: Array<any> = new Array<any>();
  selectList: any | null = null;
  loanListParameters: any = {
    active: false,
    idParameter: '',
    title: '',
    loanListDates: []
  };

  includedCompanies: Array<CompanyRef>;
  idLoanListParameter: string = '';
  name = new FormControl('', [Validators.required, Validators.minLength(3)]);

  constructor(public dialog: MatDialog, private dataService: DataSourceService, public ui: UiService) {

    
  }

  async ngOnInit() {
    this.contentLocation.tabIndex = 1;
    this.savingParameters = await this.dataService.loadLoanListParameters().pipe(take(1)).toPromise();

    this.savingParameters.forEach(element => {
      element.loanListDates.map(e => { if (e.endDate && e.startDate) { e.endDate = e.endDate.toDate(); e.startDate = e.startDate.toDate(); } });
      let id = element.idParameter;

    });

  }

  getErrorMessage() {
    return this.name.hasError('required') ? 'El Nombre del Ciclo es Requerido' :
      this.name.hasError('minLength') ? 'El Nombre debe tener mas de 3 caracteres' :
        '';
  }

  /*keyUpMethod(event: string) {
    if (event) {
      this.isNew = true;
    } else {
      this.isNew = false;
      this.contentLocation.tabIndex = 0;
    }
  }*/

  loadLoanList(event: any) {
    // index 0 new
    if (event.index) {
      this.selectList = null;
      this.loanListParameters = {
        active: false,
        idParameter: '',
        title: '',
        loanListDates: []
      };

    }

  }

/*  lastIdentifier() {
    const arrayIds = [];

   this.savingParameters.forEach(element => {
      element.loanListDates.map(e => { if (e.endDate && e.startDate) { e.endDate = e.endDate.toDate(); e.startDate = e.startDate.toDate(); } });
      let id = element.idParameter;
      arrayIds.push(id);
    });

    this.maxIdParameter = Math.max(...arrayIds);

  }*/

  selectedListChange(event: MatSelectChange) {

    this.selectList = null;
    this.loanListParameters = {
      active: false,
      idParameter: '',
      title: '',
      loanListDates: []
    };

    if (event.value) {

      this.loanListParameters = event.value;
      this.selectList = event.value;
    }


  }

  reset() {
    this.parameterSubscription = null;
    this.savingParameters = new Array<any>();
    this.contentLocation.tabIndex = 0;
  }


  saveLoanListParam() {
    console.log('edit', this.loanListParameters);
    if (!this.loanListParameters.loanListDates || this.loanListParameters.loanListDates.length < 1) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos un Ciclo de Cancelación.',
          close: 'Aceptar'
        }
      });

      return;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar los parametros  de la Lista de Espera?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(async result => {

      if (result) {
       /* if (this.loanListParameters.idParameter.length < 1) {
          // new param 
          const idParam = this.maxIdParameter > 0 ? (this.maxIdParameter + 1).toString() : '1';
          this.loanListParameters.idParameter = idParam.padStart(3, '0');
          this.loanListParameters.active = true;

          await this.dataService.insertLoanListParameters(this.loanListParameters).then(() => {

            this.reset();
            this.ngOnInit();
            this.ui.stopSpinner();

            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada.',
                close: 'Aceptar'
              }
            });

          }).catch(error => {
            this.ui.stopSpinner();
          });

        } */
          // edit param 
          this.loanListParameters.active = true;
          await this.dataService.updateLoanListParameters(this.loanListParameters).then(() => {

            this.reset();
            this.ngOnInit();
            this.ui.stopSpinner();

            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada.',
                close: 'Aceptar'
              }
            });

          }).catch(error => {
            this.ui.stopSpinner();
          });

        

      }
    });

  }

  cancelChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.reset();
        this.ngOnInit();
      }
    });

  }

}
